import { ScaleElement } from '@scale/base-element';

class ScaleLocalization extends ScaleElement {
  setup() {
    this.on('toggle', (event) => {
      if (event.target.open) this.#fill(event.target);
    }, { capture: true });

    this.onDocument('click', (event) => {
      for (const popover of this.querySelectorAll('details[data-popover][open]')) {
        if (!popover.contains(event.target)) popover.open = false;
      }
    });

    this.on('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = this.querySelector('details[open]');
      if (!open?.getClientRects().length) return;
      event.preventDefault();
      event.stopPropagation();
      open.open = false;
      open.querySelector('summary').focus();
    }, { target: window, capture: true });

    this.on('submit', (event) => {
      const returnTo = event.target.elements.return_to;
      if (returnTo) returnTo.value = this.dataset.returnTo || `${location.pathname}${location.search}`;
    });
  }

  updatedCallback() {
    for (const open of this.querySelectorAll('details[open]')) this.#fill(open);
  }

  #fill(details) {
    const panel = details.querySelector(':scope > .localization-group__panel');
    if (!panel) return;
    if (!panel.querySelector('form')) panel.append(panel.querySelector('template').content.cloneNode(true));
    this.#keepOnScreen(panel);
  }

  #keepOnScreen(panel) {
    if (getComputedStyle(panel).position !== 'absolute') return;
    delete panel.dataset.align;
    const { left, right } = panel.getBoundingClientRect();
    if (left < 0 || right > document.documentElement.clientWidth) panel.dataset.align = 'end';
  }

  filterCountries(event) {
    const fold = (text) => text.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLocaleLowerCase();
    const query = fold(event.target.value.trim());
    const form = event.target.closest('form');
    let shown = 0;
    for (const option of form.querySelectorAll('.localization__option')) {
      const match = fold(option.textContent).includes(query);
      option.parentElement.hidden = !match;
      if (match) shown += 1;
    }
    for (const subheading of form.querySelectorAll('.localization__subheading')) {
      subheading.hidden = query !== '';
    }
    form.querySelector('.localization__empty').hidden = shown > 0;
  }

  pickSearchedCountry(event) {
    if (event.key !== 'Enter') return;
    event.preventDefault();
    event.target.closest('form').querySelector('li:not([hidden]) > .localization__option')?.click();
  }
}

if (!customElements.get('scale-localization')) {
  customElements.define('scale-localization', ScaleLocalization);
}
